import { Outlet } from "react-router-dom";

const LoggedOutLayout: React.FC = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default LoggedOutLayout;
